import { useSelector, shallowEqual } from 'react-redux';

import { selectedAddress } from 'state/selected-address/selected-address-slice';

export const useAddresses = () => {
  const currentAddress = useSelector(selectedAddress, shallowEqual) || {};

  return [
    {
      flatNumber: currentAddress.flatNumber,
      houseNumber: currentAddress.houseNumber,
      houseName: currentAddress.houseName,
      addressLine1: currentAddress.addressLine1 || '',
      addressLine2: currentAddress.addressLine2 || '',
      postalTown: currentAddress.postalTown,
      county: currentAddress.county,
      postcode: currentAddress.postcode,
      dependentLocality: currentAddress.dependentLocality,
      doubleDependentLocality: currentAddress.doubleDependentLocality,
      udprn: currentAddress.udprn
    }
  ];
};
